// Number of interactions to display by default.
export const ROW_LIMIT = 30;
